import { ANON_USER_COOKIE } from '@anm/constants/auth';
import * as cookie from '@anm/helpers/cookie';
import { toUrlParams } from '@anm/helpers/parseParams';
import * as semrush from '@anm/helpers/semrush';
import { NextPageContext } from 'next';

import vtConfig from '../config';
import routes from '../routes';

const { Router } = routes;

const getToken = (req?: NextPageContext['req']) => {
  const originCookie = req && req.headers.cookie;
  const { cookieName } = vtConfig().auth;
  return cookie.get(cookieName, originCookie);
};

const checkAnon = (req?: NextPageContext['req']) => {
  const originCookie = req && req.headers.cookie;
  return JSON.parse(cookie.get(ANON_USER_COOKIE, originCookie) || 'false');
};

type RedirectPageName = 'login' | 'main';
export type AuthGuardProps = NextPageContext & { redirectTo?: RedirectPageName };

const getRedirectRoute = ({ redirectTo, asPath }: Pick<AuthGuardProps, 'redirectTo' | 'asPath'>) => {
  switch (redirectTo) {
    case 'login': {
      const params = toUrlParams({ redirectUrl: asPath }, false);
      return `/login?${params}`;
    }
    default: {
      return '/';
    }
  }
};

const authGuard = ({ res, req, asPath, redirectTo = 'main', query }: AuthGuardProps) => {
  const route = getRedirectRoute({ asPath, redirectTo });

  const token = getToken(req);
  const isAnon = checkAnon(req);
  const isSemrush = semrush.isSemrushIframe() || !!query.jwt;
  const canRedirect = !isSemrush;

  if (token && !isAnon) return token;

  if (res && canRedirect) {
    res.writeHead(302, { Location: route });
    res.end();
    return;
  }

  canRedirect && Router.push(route);
};

export default authGuard;
